import { useMemo } from "react";
import { removeSupportedExtensions } from "./matchers";
import { routeNode } from "./router";
import { sortRoutes } from "./sortRoutes";
function useSitemap() {
  return useMemo(function() {
    return getSitemap(routeNode);
  }, [
    routeNode
  ]);
}
function getSitemap(root) {
  return root ? mapRouteToSitemap(root, []) : null;
}
function mapRouteToSitemap(route, parents) {
  var _route_internal, _route_generated;
  return {
    contextKey: route.contextKey,
    filename: getRouteFilename(route),
    href: getRouteHref(route, parents),
    isInitial: route.initialRouteName === route.route,
    isInternal: (_route_internal = route.internal) !== null && _route_internal !== void 0 ? _route_internal : false,
    isGenerated: (_route_generated = route.generated) !== null && _route_generated !== void 0 ? _route_generated : false,
    children: [
      ...route.children
    ].sort(sortRoutes).map(function(child) {
      return mapRouteToSitemap(child, getRouteSegments(route, parents));
    })
  };
}
function getRouteSegments(route, parents) {
  return [
    ...parents,
    ...route.route.split("/")
  ];
}
function getRouteHref(route, parents) {
  var path = getRouteSegments(route, parents).map(function(segment) {
    return segment === "index" ? "" : segment;
  }).filter(Boolean).join("/");
  return `/${path}`;
}
function getRouteFilename(route) {
  var contextKey = removeSupportedExtensions(route.contextKey);
  var segments = contextKey.split("/");
  if (route.contextKey.match(/_layout\.[jt]sx?$/)) {
    return segments.slice(-2).join("/");
  }
  var routeSegmentsCount = route.route.split("/").length;
  return segments.slice(-routeSegmentsCount).join("/");
}
export {
  getSitemap,
  useSitemap
};
//# sourceMappingURL=sitemap.js.map
